import React, { useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { Duration } from "dayjs/plugin/duration";
import dayjs from "dayjs";

const timeoutStrings = getStrings().component.orderTimeout;

export const ExpirationCounter = (props: { expiryTimestamp?: string, onExpiration?: () => void }) => {

	const [timeLeft, setTimeLeft] = useState<Duration>();

	const interval = useRef<NodeJS.Timer>()

	useEffect(() => {

		if (props.expiryTimestamp)
		{
			interval.current = setInterval(() => {
				//Vi sätter tiden till 5 min mindre än den verkliga tiden, så har man lite extra tid på sig i eventuellt extern betalning
				setTimeLeft(dayjs.duration(dayjs(props.expiryTimestamp).subtract(5, "minutes").diff(dayjs())));
			}, 1000);
			console.debug("interval set", interval);
		}
		else
		{
			clearInterval(interval.current);
			interval.current = null;
			console.debug("interval cleared - no expiry set", interval.current);
		}

		return () => {
			clearInterval(interval.current);
			interval.current = null;
			console.debug("interval cleared - unmounted", interval);
		};
	}, [props.expiryTimestamp]);

	useEffect(() => {
		if (timeLeft && timeLeft.asSeconds() < 0)
		{
			clearInterval(interval.current);
			interval.current = null;
			console.debug("interval cleared - expired", interval.current);
			if (props.onExpiration)
				props.onExpiration();

		}
	}, [timeLeft]);

	if (!props.expiryTimestamp)
		return null;

	return <Alert show={timeLeft?.asMinutes() < 5} variant={timeLeft?.asMinutes() < 2 ? "danger" : "warning"}>{timeoutStrings.timeLeftPrompt}: <strong>{timeLeft?.minutes() > 0 ? timeLeft?.format("mm:ss") : `${timeLeft?.seconds()}s`}</strong></Alert>
}